import CustomInput from "../../../../../../Component/DigitalMarketing/CustomInput";

const Vitals = (props: any) => {
  const { formData, setFormData, handleChange, submit } = props;

  return (
    <div className="row mt-2">
      <span className="prescription-headline col-12 rounded">Vitals</span>

      {/* Row 1 - Pulse Rate & Blood Pressure */}
      <div className="d-flex gap-3 flex-wrap mt-2">
        <CustomInput
          {...formData}
          onChange={handleChange}
          type="text"
          label="Pulse Rate (Bpm)"
          validation="required"
          submit={submit}
          name="pulseRate"
          setFormData={setFormData}
        />
        <CustomInput
          {...formData}
          onChange={handleChange}
          type="text"
          label="Blood Pressure (mmHg)"
          validation="required"
          submit={submit}
          name="bloodPressure"
          setFormData={setFormData}
        />
      </div>

      {/* Row 2 - Allergy, History, Investigations, Notes */}
      <div className="d-flex gap-3 flex-wrap mt-3">
        <CustomInput
          {...formData}
          onChange={handleChange}
          type="text"
          label="Allergy"
          submit={submit}
          name="allergy"
          setFormData={setFormData}
        />
        <CustomInput
          {...formData}
          onChange={handleChange}
          type="text"
          label="History"
          submit={submit}
          name="history"
          setFormData={setFormData}
        />
        <CustomInput
          {...formData}
          onChange={handleChange}
          type="textarea"
          label="Investigations"
          submit={submit}
          name="investigations"
          setFormData={setFormData}
        />
        <CustomInput
          {...formData}
          onChange={handleChange}
          type="textarea"
          label="Notes"
          submit={submit}
          name="notes"
          setFormData={setFormData}
        />
      </div>
    </div>
  );
};

export default Vitals;
